module.exports = __webpack_public_path__ + "img/345051d.png";